import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { openFile, byteSize, Translate, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './inspection-item-performed.reducer';
import { IInspectionItemPerformed } from 'app/shared/model/inspection-item-performed.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, DEFAULT_ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const InspectionItemPerformed = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const inspectionItemPerformedList = useAppSelector(state => state.inspectionItemPerformed.entities);
  const loading = useAppSelector(state => state.inspectionItemPerformed.loading);
  const totalItems = useAppSelector(state => state.inspectionItemPerformed.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <h2 id="inspection-item-performed-heading" data-cy="InspectionItemPerformedHeading">
        <Translate contentKey="fleetSenseApp.inspectionItemPerformed.home.title">Inspection Item Performeds</Translate>
        <div className="d-flex justify-content-end">
          <Button className="mr-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="fleetSenseApp.inspectionItemPerformed.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="fleetSenseApp.inspectionItemPerformed.home.createLabel">Create new Inspection Item Performed</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {inspectionItemPerformedList && inspectionItemPerformedList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="fleetSenseApp.inspectionItemPerformed.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('satisfied')}>
                  <Translate contentKey="fleetSenseApp.inspectionItemPerformed.satisfied">Satisfied</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('observations')}>
                  <Translate contentKey="fleetSenseApp.inspectionItemPerformed.observations">Observations</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('image')}>
                  <Translate contentKey="fleetSenseApp.inspectionItemPerformed.image">Image</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.inspectionItemPerformed.inspectionItem">Inspection Item</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="fleetSenseApp.inspectionItemPerformed.inspectionHistory">Inspection History</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {inspectionItemPerformedList.map((inspectionItemPerformed, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${inspectionItemPerformed.id}`} color="link" size="sm">
                      {inspectionItemPerformed.id}
                    </Button>
                  </td>
                  <td>{inspectionItemPerformed.satisfied ? 'true' : 'false'}</td>
                  <td>{inspectionItemPerformed.observations}</td>
                  <td>
                    {inspectionItemPerformed.image ? (
                      <div>
                        {inspectionItemPerformed.imageContentType ? (
                          <a onClick={openFile(inspectionItemPerformed.imageContentType, inspectionItemPerformed.image)}>
                            <img
                              src={`data:${inspectionItemPerformed.imageContentType};base64,${inspectionItemPerformed.image}`}
                              style={{ maxHeight: '30px' }}
                            />
                            &nbsp;
                          </a>
                        ) : null}
                        <span>
                          {inspectionItemPerformed.imageContentType}, {byteSize(inspectionItemPerformed.image)}
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>
                    {inspectionItemPerformed.inspectionItem ? (
                      <Link to={`inspection-item/${inspectionItemPerformed.inspectionItem.id}`}>{inspectionItemPerformed.inspectionItem.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {inspectionItemPerformed.inspectionHistory ? (
                      <Link to={`inspection-history/${inspectionItemPerformed.inspectionHistory.id}`}>{inspectionItemPerformed.inspectionHistory.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${inspectionItemPerformed.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${inspectionItemPerformed.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`${match.url}/${inspectionItemPerformed.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="fleetSenseApp.inspectionItemPerformed.home.notFound">No Inspection Item Performeds found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={inspectionItemPerformedList && inspectionItemPerformedList.length > 0 ? '' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default InspectionItemPerformed;
